import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Category from "../pages/category/page";
import About from "../pages/about/page";
import Submit from "../pages/submit/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/category/:slug",
    element: <Category />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/submit",
    element: <Submit />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;